













































































































































































































































































































































































































































































































































/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
// import { Component, Vue, Prop } from 'vue-property-decorator';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
import SideTabRight from "@/components/SideTabRight.vue";
import Number from "@/shared/filters/Number.ts";
import { InspectionItem } from "@/model/InspectionSeibi";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { DO_SEIBI } from "@/model/DoSeibi";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { buhinList } from "@/model/InspectionSeibi";
import { INSPECT_VALUE_VIEW_TYPE } from "@/model/InspectValueViewType";
import HibiValue from "@/components/HibiValue.vue";

@Component({
  components: {
    appSideTabRight: SideTabRight,
    ConfirmDialog,
    InputNumber,
    HibiValue
  },
  filters: {
    Number
  }
})
export default class WorkDetail extends Vue {
  readonly INSPECT_VALUE_VIEW_TYPE = INSPECT_VALUE_VIEW_TYPE;
  reqService: requestService;
  sktControll: SocketControllers;
  // @Prop() id: string;
  id: any;
  doTenken: number = 0;
  workName: string = "";
  guideLine: string = "「走行2万km～3万km毎」又は\n「残量1.0mm～1.2mm」";
  inspectCommentBody: string = "";
  inspectCommentTitle: string = "";
  meyasuTime: number = 0;
  savePercent: number = 50;
  warningPercent: number = 35;
  riskPercent: number = 15;
  inspect: InspectionItem = {} as InspectionItem;
  imgList: string[] = [];
  imgListWidth: number = 0;
  imgWidth: number = 0;
  imgIndex: number = 0;
  disabledPrevImg: boolean = true;
  disabledNextImg: boolean = true;
  imgTransitionCss: string = "";

  isInspect: boolean = false;
  isSeibi: boolean = false;
  isError: boolean = false;
  errorMsg: string = "";
  showDialog: boolean = false;
  showDialogKouchin: boolean = false;
  isSave: boolean = false;
  timerNotify: any = null;
  isEditBuihin: boolean = false;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  // @Getter("getByInspectDescriptionId", { namespace: "InspectSeibiAK3" })
  // seibiById!: (id: string) => SeibiItem;

  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  @Action("updateInspectDoTenken", { namespace: "InspectSeibi" })
  updateDotenken: any;

  @Action("updateDoTenkenFromSocket", { namespace: "InspectSeibi" })
  updateDoTenkenFromSocket: any;

  @Getter("doTenkenById", { namespace: "InspectSeibi" })
  doTenkenById!: (inspectType: number, inspectId: number) => number;

  @Action("setSeibiData", { namespace: "InspectSeibi" })
  setSeibiData: any;

  @Action("setListInspectId", { namespace: "InspectSeibi" })
  setListInspectId: any;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => any;

  @Getter("nextInspectId", { namespace: "InspectSeibi" })
  nextInspectId!: (id: number) => number;

  @Getter("prevInspectId", { namespace: "InspectSeibi" })
  prevInspectId!: (id: number) => number;

  @Getter("listInspectAll", { namespace: "InspectSeibiAK3" })
  listInspectAk3!: any[];

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  CROSS: number = InspectButtonValue.CROSS;
  TRIANGLE: number = InspectButtonValue.TRIANGLE;
  CIRCLE: number = InspectButtonValue.CIRCLE;

  tempBuhinList: any = [];
  isSaving: boolean = false;
  originalBuhins: any = null;

  seibiList: any = [];
  isSavingEditPrice: boolean = false; // for check save kouchin
  carSelection: any = {};
  isHasValue = false;
  loading: boolean = true;
  mode = 0;
  prevId = -1;
  nextId = -1;
  currentIndex = -1;
  loadingData = true;
  loadingText: string = MESSAGE.Loading;
  // 2022-01-31 morisako kobac-free mod [START]
  freeOfChargeNm: string = '無償対応';
  // 2022-01-31 morisako kobac-free mod [END]

  created () {
    if (this.$route.query.inspect) {
      this.isInspect = true;
      this.mode = 1;
      this.id = +this.$route.query.inspect;
      if (this.$route.query.index) {
        this.currentIndex = +this.$route.query.index;
      }
    } else {
      this.isSeibi = true;
      this.mode = 2;
      this.id = +this.$route.query.seibi;
    }

    this.setPrevNextId();
  }

  mounted() {
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.$emit("onTopTitle", "作業の詳細について");

    this.sktControll.connectSocket(this.onConnect);
    this.initData();
  }

  setPrevNextId() {
    if (this.currentIndex == -1) {
      this.$set(this, "prevId", this.prevInspectId(this.id));
      this.$set(this, "nextId", this.nextInspectId(this.id));
    } else if (this.inspect.inspectResult) {
      const result = this.inspect.inspectResult - 1;
      let prevId = -1, nextId = -1;
      const list = this.listInspectAk3[result];

      if (this.currentIndex > 0) {
        prevId = list[this.currentIndex - 1].sknInspectId;
      }
      if (this.currentIndex < list.length -1) {
        nextId = list[this.currentIndex + 1].sknInspectId;
      }
      this.$set(this, "prevId", prevId);
      this.$set(this, "nextId", nextId);
    }
  }

  initData(isReinit = false) {
    this.loadingData = true;
    this.reqService
      .getInspectSeibiAK3_2(this.uketsukeExtendsId, this.id, this.mode)
      .then(
        (data: any) => {
          this.loadingData = false;
          this.inspect = data as InspectionItem;
          this.setPrevNextId();
          this.getHibi();

          let doTenken = this.doTenkenById(
            this.inspect.sknInspectType,
            this.inspect.sknInspectId
          );
          if (doTenken && this.inspect.doTenken == 0) {
            this.inspect.doTenken = doTenken;
          } else if (this.inspect.doTenken == 0) {
            if (this.inspect.inspectResult == InspectButtonValue.CROSS) {
              this.inspect.doTenken = DO_SEIBI.suru;
            } else if (
              this.inspect.inspectResult == InspectButtonValue.CIRCLE
            ) {
              this.inspect.doTenken = DO_SEIBI.shinai;
            }
          }
          this.workName = this.inspect.inspectCommentTitle;
          this.inspectCommentBody = this.inspect.inspectCommentSankou;
          this.inspectCommentTitle = this.inspect.inspectCommentMeyasu;
          this.meyasuTime = this.inspect.koukanMeyasuTime;
          this.doTenken = this.inspect.doTenken;
          this.imgList = this.inspect.img;
          let imgWrap = document.getElementById("div-1");
          if (this.inspect.img.length > 0 && imgWrap) {
            this.checkDisableBtnImg();
            let w = imgWrap.clientWidth;
            this.imgWidth = w;
            this.imgListWidth = this.inspect.img.length * w;
          }
          if (isReinit) {
            this.$forceUpdate();
          }
        },
        (error: any) => {
          this.loadingData = false;
          this.isError = true;
          if (error.status == 204) {
            this.errorMsg = MESSAGE.NoData;
            (this.$refs.errorDialog as any).onOpen();
          } else {
            this.errorMsg = MESSAGE.SystemError;
            (this.$refs.errorDialog as any).onOpen();
          }
        }
      )
      .catch(err => {
        console.log(err);
        this.loadingData = false;
        this.isError = true;
        this.errorMsg = MESSAGE.SystemError;
        (this.$refs.errorDialog as any).onOpen();
      });
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
  }

  repleceNewline(str: string) {
    return str.replace(/\n/g, "<br/>");
  }

  onRadioClick(event: any, val: number) {
    if (!this.isError) {
      if (val && val != this.doTenken) {
        this.doTenken = +val;
      }
      // else {
      //   this.doTenken = 0;
      // }
      this.changeDoTenken();
    }
    event.preventDefault();
  }

  changeDoTenken() {
    if (this.inspect) {
      this.isSave = true;
      this.inspect.doTenken = this.doTenken;
      this.updateDotenken(this.inspect);
      this.reqService
        .updateDoTenken(
          this.uketsukeExtendsId,
          this.doTenken,
          this.inspect.sknInspectId
        )
        .then(res => {
          const userService = new UserService();
          userService.autoSaveAk7();
        });
    }
  }

  onConnect() {
    if (this.sktControll.checkSocket()) {
      // memo [start] ほぼ同タイミングで実行されるが、socketInspectSeibiの中身がsocketInspectに送られることが稀にある
      this.sktControll.socketInspect(this.onInspectcompleted);//内容分離推奨
      this.sktControll.socketInspectItem(this.onInspectItemcompleted);
      this.sktControll.socketInspectSeibi(this.onSeibiItemcompleted);
      // memo [end]
      this.sktControll.socketInspections(this.onInspectionDotenken);
    }
  }

  onInspectcompleted(frame: any) {
    const body = util.getWSData(frame);
    const seibi = { ...body };
    delete seibi.sknWorkProgressState;
    delete seibi.sknWorkProgressStateNm;
    this.setSeibiAK3Data(seibi);
    this.notify();
  }

  onInspectItemcompleted(frame: any) {
    const body = util.getWSData(frame);
    const inspect: any = { ...body };
    delete inspect.sknWorkProgressState;
    delete inspect.sknWorkProgressStateNm;
    if (
      inspect.sknInspectDescriptionId == this.inspect.sknInspectDescriptionId
    ) {
      let newInspect = { ...this.inspect, ...inspect };
      this.$set(this, "inspect", newInspect);
      this.getHibi();
      this.notify();
    }
  }

  onInspectionDotenken(frame: any) {
    if (this.isSave) {
      this.isSave = false;
    } else {
      const body = util.getWSData(frame);
      if (body.sknUketsukeInspectId == this.inspect.sknInspectId) {
        this.inspect.doTenken = body.doTenken;
        this.doTenken = body.doTenken;
        this.updateDoTenkenFromSocket(body);
        this.$forceUpdate();
        this.notify();
      }
    }
  }

  notify() {
    if (this.timerNotify) {
      clearTimeout(this.timerNotify);
      this.timerNotify = null;
    }
    this.timerNotify = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedInspections
      });
    }, 500);
  }

  onSeibiItemcompleted(frame: any) {
  //  const body = util.getWSData(frame);
  //  const seibi = { ...body };
  //  delete seibi.items.sknWorkProgressState;
  //  delete seibi.items.sknWorkProgressStateNm;
  //  this.setSeibiData(seibi);
    this.setListInspectId(this.listInspect(1));
    this.setPrevNextId();
  }

  /** 2023-10-19 invoice [START] */
  get buhinZn() {
    if (this.inspect) {
      return this.inspect.buhinZn;
    }
    return 0;
  }
  /** 2023-10-19 invoice [END] */

  get buhinZk() {
    if (this.inspect) {
      return this.inspect.buhinZk;
    }
    return 0;
  }

  /** 2023-10-19 invoice [START] */
  get kouchinZn() {
    if (this.inspect) {
      return this.inspect.kouchinZn;
    }
    return 0;
  }
  /** 2023-10-19 invoice [END] */

  get kouchinZk() {
    if (this.inspect) {
      return this.inspect.kouchinZk;
    }
    return 0;
  }

  get total() {
    let kouchinZk = this.kouchinZk;
    /** 2023-10-19 invoice [START] */
    let kouchinZn = this.kouchinZn;
    if (kouchinZn < 0) {
      kouchinZk = 0;
      kouchinZn = 0;
    }
    return this.isExcludingTax? (kouchinZn + this.buhinZn) : (kouchinZk + this.buhinZk);
    /** 2023-10-19 invoice [END] */
  }

  getValue(index: number) {
    if (
      this.inspect.inspectValue &&
      this.inspect.inspectValue.length > 0 &&
      (this.inspect.inspectValue[index] ||
       this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP)
    ) {
      return this.inspect.inspectValue[index].toFixed(1);
    }
    return "-";
  }

  getValueYm() {
    if (this.inspect.inspectValueStr && this.inspect.inspectValueStr[0]) {
      const val = this.inspect.inspectValueStr[0];
      if (val != null) {
        const val1 = parseInt(val.substring(0, 4));
        const val2 = parseInt(val.substring(4, 6));
        return `${val1}年${val2}月`;
      }
    } else if (this.inspect.inspectValue && this.inspect.inspectValue[0] === 1) {
      return 'なし　LED';
    }
    return "-";
  }

  cssBoxValue(index: number) {
    let inspectResult = this.getInspectResult(index);
    if (inspectResult == InspectButtonValue.CROSS) {
      return "risk";
    } else if (inspectResult == InspectButtonValue.CIRCLE) {
      return "save";
    } else if (inspectResult == InspectButtonValue.TRIANGLE) {
      return "warning";
    }
  }

  getInspectResult(index: number) {
    let value = this.inspect.inspectValue[index];
    if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
      //Tire
      if (value <= 2.5) {
        return InspectButtonValue.CROSS;
      }
      if (value >= 2.6 && value <= 4.0) {
        return InspectButtonValue.TRIANGLE;
      }
    } else if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE) {
      //brake pad
      if (value <= 4) {
        return InspectButtonValue.CROSS;
      }
      if (value >= 4.1 && value <= 5) {
        return InspectButtonValue.TRIANGLE;
      }
    } else if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR) {
      //brake shoe
      if (value <= 2) {
        return InspectButtonValue.CROSS;
      }
      if (value >= 2.1 && value <= 3) {
        return InspectButtonValue.TRIANGLE;
      }
    }
    return InspectButtonValue.CIRCLE;
  }

  get getTextInspectResult() {
    if (this.inspect.inspectResult == InspectButtonValue.TRIANGLE) {
      return "予防整備が必要です";
    } else if (this.inspect.inspectResult == InspectButtonValue.CROSS) {
      return "作業が必要です";
    }
    return "";
  }

  getHeightBox() {
    if (typeof this.inspect.inspectValueViewType == "number") {
      if (this.inspect.inspectValueViewType == 0) {
        return "h172";
      } else if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
        return "h67";
      }
      return "";
    }
    return "h172";
  }

  openBuhinList() {
    if (this.inspect.buhinList.length > 0) {
      this.showDialog = true;
      this.tempBuhinList = util.deepCopy(this.inspect.buhinList);
    }
  }

  onClose() {
    this.showDialog = false;
  }

  onNextImg() {
    this.imgIndex++;
    this.checkDisableBtnImg();
    this.imgTransitionCss = `transform: translateX(-${this.imgIndex *
      this.imgWidth}px)`;
  }

  onPrevImg() {
    this.imgIndex--;
    this.checkDisableBtnImg();
    if (this.imgIndex == 0) {
      this.imgTransitionCss = "";
    } else {
      this.imgTransitionCss = `transform: translateX(-${this.imgIndex *
        this.imgWidth}px)`;
    }
  }

  checkDisableBtnImg() {
    if (this.imgIndex == 0) {
      this.disabledPrevImg = true;
    } else {
      this.disabledPrevImg = false;
    }
    if (this.imgList.length > 0 && this.imgIndex == this.imgList.length - 1) {
      this.disabledNextImg = true;
    } else {
      this.disabledNextImg = false;
    }
  }

  onImgError(index: number) {
    this.$set(this.imgList, index, "");
    if (this.imgList.filter(img => img != "").length <= 1) {
      this.$set(this, "disabledPrevImg", true);
      this.$set(this, "disabledNextImg", true);
    }
  }

  resetBuhinPrice() {
    let listBuhin: any = [];
    if (this.originalBuhins) {
      listBuhin = this.inspect.buhinList.filter((buhin: any, i: number) => {
        /** 2023-10-19 invoice [START] */
        if( this.isExcludingTax ){
          return this.originalBuhins[i].buhinUnitPriceZn != buhin.buhinUnitPriceZn;
        }else{
          return this.originalBuhins[i].buhinUnitPriceZk != buhin.buhinUnitPriceZk;
        }
        /** 2023-10-19 invoice [END] */
      });
    } else {
      listBuhin = this.inspect.buhinList;
    }
    if (!this.isSaving) {
      const buhins = listBuhin.map((e: any) => {
        return { id: e.id, type: e.type };
      });
      if (buhins.length > 0) {
        const data = { sknUketsukeExtendsId: this.uketsukeExtendsId, buhins };
        this.isSaving = true;
        this.reqService.resetBuhinPriceAk3_2(data).then(() => {
          this.isSaving = false;
          this.reGetData(true);
        });
      } else {
        this.isEditBuihin = false;
      }
    }
  }

  reGetData(isReset: boolean, isResetKouchin: boolean = false) {
    this.reqService
      .getInspectSeibiAK3_2(this.uketsukeExtendsId, this.id, 1)
      .then((data: any) => {
        this.inspect = data as InspectionItem;
        if (isReset) {
          this.originalBuhins = util.deepCopy(this.inspect.buhinList);
        }
        if (isResetKouchin) {
          this.seibiList = util.deepCopy(this.inspect.seibiList);
          this.mapSeibiListForShow();
        }
        this.$forceUpdate();
      });
  }

  onCloseDialogBuhin() {
    if (this.isEditBuihin) {
      this.isEditBuihin = false;
      const buhins = this.inspect.buhinList
        .filter((buhin: any, i: number) => {
          return (
            /** 2023-10-19 invoice [START] */
            this.tempBuhinList[i].buhinUnitPriceZn != buhin.buhinUnitPriceZn ||
            this.tempBuhinList[i].buhinUnitPriceZk != buhin.buhinUnitPriceZk ||
            /** 2023-10-19 invoice [END] */
            this.tempBuhinList[i].buhinQuantity != buhin.buhinQuantity
            /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
            || this.tempBuhinList[i].isIgnore != buhin.isIgnore
            /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
          );
        })
        .map((e: any) => {
          const b = { ...e };
          /** 2023-10-19 invoice [START] */
          if (b.buhinUnitPriceZn == null) {
            b.buhinUnitPriceZn = 0;
          }
          if (b.buhinUnitPriceZk == null) {
            b.buhinUnitPriceZk = 0;
          }
          /** 2023-10-19 invoice [END] */
          delete b.buhinNm;
          // 2022-01-31 morisako kobac-free add [START]
          delete b.isDiscount;
          // 2022-01-31 morisako kobac-free add [END]
          /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
          delete b.checkIsIgnore;
          /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
          return b;
        });
      const data = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        buhins
      };
      this.reqService.saveBuhinAk3_2(data).then((res: any) => {
        this.reGetData(false);
      }, err => {
        this.$notify.error({
          title: "エラー",
          message: util.getHttpErrorMessage(err)
        });
      });
    }
  }

  /** 2023-10-19 invoice [START] */
  getBuhinTotalPriceZn(buhin: any) {
    if ((buhin.buhinQuantity * 10) % 10 > 0) {
      return Math.round(buhin.buhinQuantity * buhin.buhinUnitPriceZn * 10) / 10;
    } else {
      return buhin.buhinQuantity * buhin.buhinUnitPriceZn;
    }
  }

  getBuhinTotalPriceZk(buhin: any) {
    if ((buhin.buhinQuantity * 10) % 10 > 0) {
      return Math.round(buhin.buhinQuantity * buhin.buhinUnitPriceZk * 10) / 10;
    } else {
      return buhin.buhinQuantity * buhin.buhinUnitPriceZk;
    }
  }
  /** 2023-10-19 invoice [END] */

  onEditBuhin(buhin: any) {
    this.isEditBuihin = true;
    /** 2023-10-19 invoice [START] */
    if( this.isExcludingTax ){
      buhin.buhinTotalPriceZn = this.getBuhinTotalPriceZn(buhin);
    }else{
      buhin.buhinTotalPriceZk = this.getBuhinTotalPriceZk(buhin);
    }
    /** 2023-10-19 invoice [END] */
  }

  mapSeibiListForShow() {
    this.seibiList = this.seibiList.map((e: any) => {
      // if (!e.kouchinEditZk) {
      /** 2023-10-19 invoice [START] */
      if (!e.isKouchinEdit) {
        e.kouchinEditZn = !e.kouchinZn || e.kouchinZn < 0 ? 0 : e.kouchinZn;
        e.kouchinEditZk = !e.kouchinZk || e.kouchinZk < 0 ? 0 : e.kouchinZk;
      }
      if (e.kouchinEditZn < 0) {
        e.kouchinEditZn = 0;
      }
      if (e.kouchinEditZk < 0) {
        e.kouchinEditZn = 0;
      }
      /** 2023-10-19 invoice [END] */
      return e;
    });
  }

  openSeibiList() {
    this.showDialogKouchin = true;
    this.seibiList = util.deepCopy(this.inspect.seibiList);
    this.mapSeibiListForShow();
  }

  resetKouchin() {
    if (!this.isSavingEditPrice) {
      /** 2023-10-19 invoice [START] */
      let seibiList: any;
      if( this.isExcludingTax ){
        seibiList = this.seibiList.filter(
          (e: any) => e.kouchinEditZn != e.kouchinZn
        );
      }else{
        seibiList = this.seibiList.filter(
          (e: any) => e.kouchinEditZk != e.kouchinZk
        );
      }
      /** 2023-10-19 invoice [END] */
      if (seibiList.length > 0) {
        this.isSavingEditPrice = true;
        const promise: any = seibiList.map(async (e: any) => {
          let obj = this.mapObjEditPrice(e, false);
          return await this.reqService.updatePrice(obj);
        });
        Promise.all(promise).then(() => {
          this.isSavingEditPrice = false;
          this.reGetData(false, true);
        });
      }
    }
  }

  mapObjEditPrice(seibi: any, isEdit: boolean = true) {
    let obj: any = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      buhinEditTotalZk: null
    };
    if (isEdit) {
      if (seibi.kouchinEditZk == null) {
        seibi.kouchinEditZk = 0;
      }
      /** 2023-10-19 invoice [START] */
      if (seibi.kouchinEditZn == null) {
        seibi.kouchinEditZn = 0;
      }
      obj.kouchinEditZn = seibi.kouchinEditZn;
      /** 2023-10-19 invoice [END] */
      obj.kouchinEditZk = seibi.kouchinEditZk;
    } else {
      // obj.kouchinEditZk = seibi.kouchinZk;
      obj.kouchinEditZk = null;
      obj.kouchinEditZn = null;
    }
    if (seibi.type == 2) {
      obj.sknUketsukeInspectSeibiManualId = seibi.id;
    } else {
      obj.sknUketsukeInspectSeibiId = seibi.id;
    }
    return obj;
  }

  editKouchin(seibi: any) {
    const obj = this.mapObjEditPrice(seibi);
    this.reqService.updatePrice(obj).then((res: any) => {
      this.reGetData(false);
    }, err => {
      this.$notify.error({
        title: "エラー",
        message: util.getHttpErrorMessage(err)
      });
    });
  }

  checkHasValue() {
    if (
      this.inspect.inspectValue &&
      this.inspect.inspectValue.length > 0&&
      this.inspect.inspectValue[0] != null
    ) {
      return true;
    }
    return false;
  }

  getHibi() {
    this.isHasValue = this.checkHasValue();

    if (this.inspect.inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.TIRE) {
      this.loading = true;
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then((res: any) => {
          if (res) {
            this.carSelection = res;
            this.loading = false;
            this.$forceUpdate();
          }
        });
    } else {
      this.loading = false;
    }
  }

  goPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex --;
    }
    this.gotoDetail(this.prevId);
  }

  goNext() {
    if (this.currentIndex > -1) {
      this.currentIndex ++;
    }
    this.gotoDetail(this.nextId);
  }

  gotoDetail(id: number) {
    this.id = id;
    this.mode = 1;
    this.setPrevNextId();
    this.initData(true);
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }
  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) {
        this.freeOfChargeNm = res.freeOfChargeNm;
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
  onChangeIsIgnore(buhin: any) {
    this.isEditBuihin = true;
    buhin.isIgnore = buhin.checkIsIgnore ? 0: 1;
    /** 2023-10-19 invoice [START] */
    if( this.isExcludingTax ){
      buhin.buhinTotalPriceZn = this.getBuhinTotalPriceZn(buhin);
    }else{
      buhin.buhinTotalPriceZk = this.getBuhinTotalPriceZk(buhin);
    }
    /** 2023-10-19 invoice [END] */
  }
  isNeedBuhin(buhin: any) {
    return buhin.isIgnore == 0;
  }
  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Watch("listInspectAk3")
  reInitData() {
    this.initData();
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
